(function () {
  'use strict';
  function initialize() {
    document.querySelectorAll('[data-bioss-lab-essentials]').forEach(function (root) {
      if (root.dataset.labReady) return;
      root.dataset.labReady = 'true';
      var marker = root.querySelector('[data-lab-marker]');
      var products = Array.from(root.querySelectorAll('[data-lab-product]'));
      function switchMarker() {
        products.forEach(function (card) { card.hidden = card.dataset.labProduct !== marker.value; });
      }
      if (marker && marker.options.length) {
        marker.closest('.bioss-lab__chooser').hidden = false;
        marker.addEventListener('change', switchMarker);
        switchMarker();
      } else {
        root.querySelector('.bioss-lab__ladders').hidden = true;
      }
      if (!root.querySelector('.bioss-lab__kit')) root.querySelector('.bioss-lab__kits').hidden = true;
      if (!products.length && !root.querySelector('.bioss-lab__kit')) root.hidden = true;
      products.forEach(function (card) {
        var select = card.querySelector('[data-lab-variant]');
        var button = card.querySelector('[data-lab-add]');
        var details = card.querySelector('[data-lab-details]');
        var form = card.querySelector('form');
        var status = card.querySelector('[data-lab-status]');
        var busy = false;
        function update() {
          var option = select.options[select.selectedIndex];
          var available = Boolean(option && option.dataset.available === 'true');
          card.querySelector('[data-lab-price]').textContent = option ? option.dataset.price : '';
          card.querySelector('[data-lab-price]').hidden = false;
          card.querySelector('[data-lab-sku]').textContent = option ? option.dataset.sku : '';
          button.disabled = busy || !available;
          button.textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
          if (option) {
            var url = new URL(details.href, window.location.href);
            url.searchParams.set('variant', option.value);
            details.href = url.href;
          }
        }
        select.addEventListener('change', function () {
          status.textContent = '';
          status.hidden = true;
          update();
        });
        form.addEventListener('submit', async function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          var option = select.options[select.selectedIndex];
          if (busy || !option || option.disabled || option.dataset.available !== 'true') return;
          busy = true;
          button.disabled = true;
          select.disabled = true;
          form.setAttribute('aria-busy', 'true');
          status.hidden = false;
          status.textContent = form.dataset.addingLabel;
          var controller = new AbortController();
          var timeout = setTimeout(function () { controller.abort(); }, 20000);
          try {
            var response = await fetch(form.action.replace(/\/$/, '') + '.js', {
              method: 'POST', credentials: 'same-origin', signal: controller.signal,
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: option.value, quantity: 1 }] })
            });
            var result = await response.json();
            if (!response.ok || !result.items || !result.items.some(function (item) { return String(item.id) === option.value; })) throw new Error('Unconfirmed add');
            status.textContent = form.dataset.addedLabel;
            var cartRoot = form.action.replace(/cart\/add\/?$/, '');
            fetch(cartRoot + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
              .then(function (r) { if (!r.ok) throw new Error('Cart unavailable'); return r.json(); })
              .then(function (cart) {
                if (window.StyleHatch && typeof window.StyleHatch.updateCartButton === 'function') window.StyleHatch.updateCartButton(cart);
                var count = document.getElementById('CartCount');
                if (count) count.textContent = cart.item_count;
                if (window.BiossCartDrawer && typeof window.BiossCartDrawer.refresh === 'function') return window.BiossCartDrawer.refresh();
              }).catch(function () {});
          } catch (error) {
            status.textContent = form.dataset.failedLabel;
          } finally {
            clearTimeout(timeout);
            busy = false;
            select.disabled = false;
            form.removeAttribute('aria-busy');
            update();
          }
        }, true);
        update();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
